import React from 'react';
import { useFormContext } from 'react-hook-form';
import style from './fields.module.scss';
import FormTextField from 'controls/textField/formTextField';
import FormPassword from 'controls/password/formPassword';
import { AuthType, langs } from 'pages/login/types';
import { getErrorsProps } from 'utils/utils';

export default function Fields(props: { type: AuthType }) {
  const {
    formState: { errors },
  } = useFormContext();
  const l = langs[props.type];

  const adaptedErrors = getErrorsProps(errors);
  return (
    <div className={style.container}>
      {props.type === 'signup' && (
        <>
          <FormTextField
            name="name"
            rules={{ required: true }}
            inner_props={{
              label: 'Имя',
              InputProps: {
                placeholder: 'Ваше имя',
              },
              ...adaptedErrors['name'],
            }}
          ></FormTextField>
          <FormTextField
            name="surname"
            rules={{ required: true }}
            inner_props={{
              label: 'Фамилия',
              InputProps: {
                placeholder: 'Ваша фамилия',
              },
              ...adaptedErrors['surname'],
            }}
          ></FormTextField>
        </>
      )}
      <FormTextField
        name="email"
        rules={{ required: true }}
        inner_props={{
          label: 'Корпоративный E-mail',
          InputProps: {
            placeholder: 'example@transport.mos.ru',
          },
          ...adaptedErrors['email'],
        }}
      ></FormTextField>
      {props.type === 'signup' && (
        <FormTextField
          name="organization"
          rules={{ required: true }}
          inner_props={{
            label: 'Название организации',
            InputProps: {
              placeholder: 'Например: ЦОДД',
            },
            ...adaptedErrors['organization'],
          }}
        ></FormTextField>
      )}
      <FormPassword
        name="password"
        rules={{ required: true }}
        inner_props={{
          input_label_props: {
            children: l.password,
          },
          input_props: {
            ...adaptedErrors['password'],
          },
        }}
      ></FormPassword>
    </div>
  );
}
